import {MultiColumnComboBox} from "@progress/kendo-react-dropdowns"
import {FieldRenderProps} from "@progress/kendo-react-form"
import React from "react"

const BookingMultiColumnComboBox = (fieldRenderProps: FieldRenderProps): JSX.Element => {
    const {
        disabled,
        required,
        allowCustom,
        name,
        value,
        textField,
        dataItemKey,
        data,
        columns,
        label,
        filterable,
        itemRender,
        loading,
        onFilterChange,
        onChange,
        placeholder,
    } = fieldRenderProps

    let selectedValue = data.find((x: {[x: string]: any}) => x[`${dataItemKey}`] === value)
    return (
        <MultiColumnComboBox
            // valueRender={valueRender}
            disabled={disabled}
            allowCustom={allowCustom}
            required={required}
            name={name}
            value={selectedValue}
            textField={textField}
            dataItemKey={dataItemKey}
            data={data}
            columns={columns}
            label={label}
            itemRender={itemRender}
            filterable={filterable}
            loading={loading}
            onFilterChange={onFilterChange}
            onChange={onChange}
            placeholder={placeholder}
            />
    )
}

export default React.memo(BookingMultiColumnComboBox)
